export const R = {
	"InsuranceProviderFreeAccess": "Customers at {0} have &lt;b&gt;free access&lt;/b&gt; to:",
	"AdditionalServicesSelfPayment": "Additional services are available for &lt;b&gt;self-payment&lt;/b&gt;.",
	"AdditionalServicesNotAvailable": "Additional services are &lt;b&gt;not available&lt;/b&gt;.",
	"ReferralsHeading": "Referrals",
	"ReferralsCanBeReferredTo": "Customers of {0} can be referred to:",
	"ReferralsSentViaXMedicus": "Referrals are sent directly in XMedicus",
	"ReferralsPatientSendsCopy": "Patient sends copy of medical record to company",
	"AdditionalInfoHeading": "Other"
}